import productApi, { ProductResponse } from "../../api/product/productApi";
import { useGetApi } from "../hooks";

type UseGetProductParams = {
  params?: Record<string, string | number | boolean>;
  enabled?: boolean;
  allResponse?: boolean;
  onSuccess?: (data: any) => void;
  onError?: (error: unknown) => void;
};

export const useGetProduct = ({
  params = {},
  enabled = false,
  onError,
  onSuccess
}: UseGetProductParams) =>
  useGetApi<ProductResponse>({
    fetch: () => productApi.getProduct({ params }),
    key: ["productApi.getProduct", { params }],
    enabled,
    onSuccess,
    onError,
  });